import HeadphonesIcon from '@mui/icons-material/Headphones';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
  ArrayInput, AutocompleteInput, BooleanInput, FormDataConsumer, ReferenceInput, SimpleFormIterator, TextInput, required,
} from 'react-admin';

import EngineerAwardsInput from './EngineerAwardsInput';
import { getResourceFilter } from '@/constants';

function AlbumEngineersSection() {
  return (
    <Box
      mb={3} width={{ xs: '100%', md: '70%' }}
      p={2} border={1}
      borderRadius={2} borderColor='grey.400'
    >
      <Typography
        variant='h6' gutterBottom
        display='flex' alignItems='center'
        gap={1}
      >
        <HeadphonesIcon />
        Engineers
      </Typography>
      <ArrayInput source='DiscographyAlbumEngs' label=''>
        <SimpleFormIterator disableReordering disableClear>
          <ReferenceInput
            label='Engineers'
            source='ResourceIdentifier'
            reference='resources'
            alwaysOn
            filter={{ ...getResourceFilter() }}
          >
            <AutocompleteInput
              optionText='Name' label='Engineers'
              filterToQuery={(q) => ({ Name: q })} validate={required()}
            />
          </ReferenceInput>
          <Box
            mt={2} display='flex'
            gap={2}
          >
            <BooleanInput source='SelectedWork' label='Selected Work' />
            <BooleanInput source='CareerHighlight' label='Career Highlight' />
            <BooleanInput source='PostInstagram' label='Post Instagram' />
          </Box>

          <EngineerAwardsInput />

          {/* Atmos with inline track field */}
          <Box
            mt={2} display='flex'
            alignItems='center' gap={2}
          >
            <BooleanInput source='Atmos' label='Atmos' />
            <FormDataConsumer>
              {({ scopedFormData }) => (scopedFormData && scopedFormData.Atmos ? (
                <TextInput
                  source='AtmosTracks' label='Atmos Track'
                  sx={{ flexGrow: 1 }}
                />
              ) : null)}
            </FormDataConsumer>
          </Box>

          {/* Stereo with inline track field */}
          <Box
            mt={2} display='flex'
            alignItems='center' gap={2}
          >
            <BooleanInput source='Stereo' label='Stereo' />
            <FormDataConsumer>
              {({ scopedFormData }) => (scopedFormData && scopedFormData.Stereo ? (
                <TextInput
                  source='StereoTracks' label='Stereo Track'
                  sx={{ flexGrow: 1 }}
                />
              ) : null)}
            </FormDataConsumer>
          </Box>

          {/* Vinyl */}
          <Box
            mt={2} display='flex'
            alignItems='center' gap={2}
          >
            <BooleanInput source='Vinyl' label='Vinyl' />
          </Box>

        </SimpleFormIterator>
      </ArrayInput>
    </Box>
  );
}

export default AlbumEngineersSection;
